const naturalNumberRegex = /^[0-9]+$/;

export const isNaturalNumber = (value) => {
    return value.match(naturalNumberRegex);
}